/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable prefer-rest-params */
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { GoalInterface } from '../../+models';
import { ModelApiBase, PolpoApi } from '../shared';

@Injectable({ providedIn: 'root' })
export class GoalApi extends ModelApiBase {
  constructor(api: PolpoApi) {
    super(api, 'Goals');
  }

  getGoalsForLearningArea(learningAreaId: number): Observable<GoalInterface[]> {
    const path = `learning-area/${learningAreaId}`;
    return this.get<GoalInterface[]>(path, undefined);
  }

  deleteGoal(goalId: number): Observable<any> {
    const path = `delete-goal/${goalId}`;
    return this.delete<any>(path, undefined);
  }

  upsertGoal(goal: GoalInterface): Observable<GoalInterface> {
    const path = 'upsert-goal';
    return this.post<GoalInterface>(path, undefined, goal);
  }

  updateDisplayOrders(goals: Pick<GoalInterface, 'id' | 'displayOrder'>[]): Observable<GoalInterface[]> {
    const path = 'update-display-orders';
    return this.post<GoalInterface[]>(path, undefined, goals);
  }
}
